import { render, staticRenderFns } from "./myNav.vue?vue&type=template&id=70aab196&scoped=true"
import script from "./myNav.vue?vue&type=script&lang=js"
export * from "./myNav.vue?vue&type=script&lang=js"
import style0 from "./myNav.vue?vue&type=style&index=0&id=70aab196&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aab196",
  null
  
)

export default component.exports